import INFTCollections from '../../models/INFTCollections'
import NeonMonstersCard from '../../nftFormats/NeonMonsters/Card/NeonMonstersCard'
import NeonMonstersDetail from '../../nftFormats/NeonMonsters/Detail/NeonMonstersDetail'
import NeonMonstersActivityDetail from '../../nftFormats/NeonMonsters/Activity/NeonMonstersActivityDetail'
import NeonMonstersLogo from '../../../../assets/nft-logo/NeonMonsters.jpg'

export const NeonMonstersData: INFTCollections[] = [
  {
    id: 'NeonMonsters',
    tokenAddress: '0x1b72cfde16e5a33a36eaafbf2eb9cded02b09577',
    name: 'Neon Monsters v1',
    cardFormat: NeonMonstersCard,
    detailFormat: NeonMonstersDetail,
    activityFormat: NeonMonstersActivityDetail,
    category: 1,
    creatorAddress: '0x92a9B8684850E895240Cf08F53Edd95bfd739441',
    logo: NeonMonstersLogo,
    website: 'https://www.neonmonsters.net/',
    twitter: '0xNeonMonsters',
    telegram: 'https://t.me/neonmonsters',
    discord: 'https://discord.com/invite/Ye9JkbGH',
    oldProject: true
  },
  {
    id: 'NeonMonstersv2',
    tokenAddress: '0xb47d3Cd10DB2f035e14163e3D96F2B2F92eB66e2',
    name: 'Neon Monsters v2',
    cardFormat: NeonMonstersCard,
    detailFormat: NeonMonstersDetail,
    activityFormat: NeonMonstersActivityDetail,
    category: 1,
    creatorAddress: '0x92a9B8684850E895240Cf08F53Edd95bfd739441',
    logo: NeonMonstersLogo,
    website: 'https://www.neonmonsters.net/',
    twitter: '0xNeonMonsters',
    telegram: 'https://t.me/neonmonsters',
    discord: 'https://discord.com/invite/Ye9JkbGH'
  }
]

export const NeonMonstersCategoryData = {
  [NeonMonstersData[0].tokenAddress.toLowerCase()]: NeonMonstersData[0].category
}
